jQuery(document).ready(function($){
    function wm_init_slider() {
        let slider_opts = {
            dots: false,
            speed: 300,
            infinite: false,
            autoplay: false,
            fade: false,
            autoplaySpeed: 5000,
            cssEase: 'ease-out',
            arrows: false,
            prevArrow: '<button type="button button--outline" class="slick-prev"><i class="icon-chevron-left"></i></button>',
            nextArrow: '<button type="button button--outline" class="slick-next"><i class="icon-chevron-right"></i></button>',
        };

        let slider_style = $(this).data('slider-style') || 'medium';

        let slider_styles = {
            'single': {
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: false,
                arrows: true,
            },
            'medium': {
                slidesToShow: 3,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 800,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ],
            },
            'variable': {
                variableWidth: true,
                swipeToSlide: true,
                outerEdgeLimit: true,
                responsive: false,
                dots: false,
                slidesToShow: 7,
                infinite: true,
            },
            'logos-carousel': {
                variableWidth: true,
                responsive: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 400,
                infinite: true,
                centerMode: true,
            },
            'product3-items': {
                variableWidth: true,
                responsive: false,
                dots: false,
                arrows: true,
            }
        };

        slider_opts = Object.assign({}, slider_opts, slider_styles[slider_style]);

        let $slider_parent = $(this).parents('[data-slider-parent]');

        if ($slider_parent.length) {
            let $arrows = $slider_parent.find('[data-slider-arrows]');

            if ($arrows.length) {
                slider_opts.appendArrows = $arrows;
            }

            let $dots = $slider_parent.find('[data-slider-dots]');

            if ($dots.length) {
                slider_opts.appendDots = $dots;
            }

            let $nav_items = $slider_parent.find('[data-slider-goto]');

            if ($nav_items.length) {
                let $slider = $slider_parent.find('[data-slider]');
                $slider.on('afterChange', function(event, slick, currentSlide) {
                    $nav_items.removeClass('is-active');
                    $slider_parent.find(`[data-slider-goto="${currentSlide}"`).addClass('is-active');
                });
            }

            if (slider_style == 'portfolio-nav') {
                let $nav_target = $slider_parent.find('[data-slider-nav-target]');

                if ($nav_target.length) {
                    slider_opts.asNavFor = $nav_target.eq(0);
                }
            }
        }

        $(this).slick(slider_opts);

    }

    if ($('[data-slider]').length) {
        $('[data-slider]').each(wm_init_slider);
    }

    $('[data-slider-goto]').click(function() {
        let slide_index = $(this).data('slider-goto');
        slide_index = parseInt(slide_index);

        $(this).siblings().removeClass('is-active');
        $(this).addClass('is-active');

        let $parent = $(this).closest('[data-slider-parent]');

        if (!$parent.length) {
            return;
        }

        let $slider = $parent.find('[data-slider]');

        if (!$slider.length) {
            return;
        }

        $slider.slick('slickGoTo', slide_index);
    });

    $('.products2').on('click', '.slick-arrow', function() {
        let $slider_parent = $(this).parents('[data-slider-parent]');
        let $slider = $slider_parent.find('[data-slider]');
        let cmd = $(this).hasClass('slick-prev') ? 'slickPrev' : 'slickNext';
        $slider.slick(cmd);
    });

});
